
/////// Functions: ///////
// -----------------------

function initPage()
{
        // Add eventhandlers on toggle-buttons
         $('.DIRECTORY_MANAGEMENT input[type=button]').click(function (e) {
             e.preventDefault();

             var $this = $(this).parent().find('.DIRECTORY_BROWSER');
             $('.DIRECTORY_BROWSER').not($this).hide();
             $this.toggle();

             var btn = $(this).attr('id');
             if (btn == "btn_change_bckdata") {
                 dirType = 'backdata';
             }
             else if (btn == "btn_change_raw") {
                 dirType = 'rawdata';
             }
             else if (btn == "btn_change_survey") {
                 dirType = 'surveydata';
             }

             onButtonClick(this);
         });
				 
				/*$('.DIRECTORY_MANAGEMENT input[type=button]').click(function() {
					// Open/show the add new dialog
					folderBrowser.toggleAddDialog(true);
				});
				
				$('.dialog-currentpath').on("onUpdate", function(event, val) {
					fillDirectories(val);
				});*/

        // Add eventhandlers on browse-buttons
        $('.DIRECTORY_BROWSER #button_cdup').click(function (e) {
            e.stopPropagation();
            e.preventDefault();
            cdUp();
        });

        //$('#button_check').click({ val: $('#DIR_SELECT_PATH').text() }, fillDirectoryInput);
        $('.DIRECTORY_BROWSER #button_check').click(function (e) {
            e.stopPropagation();
            e.preventDefault();
            fillDirectoryInput();
        });

        hideFolderBrowsers();
				finishedLoadingPage();				
}

function hideFolderBrowsers() 
{
    $('.DIRECTORY_MANAGEMENT').parent().find('.DIRECTORY_BROWSER');
    $('.DIRECTORY_BROWSER').hide();
}

function storeTemplate(val) 
{
    sendOk();
    window.open("./Survey_newSurvey.html", "_self");
}

function cancelTemplate(val) 
{
    window.open("./Survey_newSurvey.html", "_self");
}

function cdUp()
{ 
    sendValues('DIR_SELECT_BROWSE=1') 
}

function fillDirectories(input)
{
	var s = dirType;
	
	if (s.indexOf('backdata') > -1) 
    {
        var path = (input);
        var toSend = "SURVEY_TEMPLATE_ADD_BACKGROUND_DATA=" + encodeURIComponent(path);
        sendValues(toSend);
    }
    else if (s.indexOf('rawdata') > -1) 
    {
        $('#SURVEY_TEMPLATE_RAW_DATA input[type=text]').val(input);
        var toSend = $('#SURVEY_TEMPLATE_RAW_DATA input[type=text]').serialize();
        sendValues(toSend);
    }
    else if (s.indexOf('surveydata') > -1) 
    {
       $('#SURVEY_TEMPLATE_SURVEY_DATA input[type=text]').val(input);
       var toSend = $('#SURVEY_TEMPLATE_SURVEY_DATA input[type=text]').serialize();
       sendValues(toSend);
    }
}

function fillDirectoryInput() 
{
        
    var s = dirType;
    //var elem = $("div#"+"SURVEY_TEMPLATE_TOPDIR");
    //var inp = elem.find("input#"+"SURVEY_TEMPLATE_TOPDIR");
    //$('#SURVEY_TEMPLATE_TOPDIR input[type=text]').val(val);

    if (s.indexOf('backdata') > -1) 
    {
        //$('#SURVEY_TEMPLATE_BACKGROUND_DATA input[type=text]').val(val+"/background");
        //var toSend = $('#SURVEY_TEMPLATE_BACKGROUND_DATA input[type=text]').serialize();
        var val = $('#DIR_SELECT_USE_DIRECTORY_BACKDATA option:selected').text();

        var path = (val + "/background");
        var toSend = "SURVEY_TEMPLATE_ADD_BACKGROUND_DATA=" + encodeURIComponent(path);
        sendValues(toSend);
    }
    else if (s.indexOf('rawdata') > -1) 
    {
        var val = $('#DIR_SELECT_USE_DIRECTORY_RAW option:selected').text();

        $('#SURVEY_TEMPLATE_RAW_DATA input[type=text]').val(val + "sisdata/raw");
        var toSend = $('#SURVEY_TEMPLATE_RAW_DATA input[type=text]').serialize();
        sendValues(toSend);
    }
    else if (s.indexOf('surveydata') > -1) 
    {
       var val = $('#DIR_SELECT_USE_DIRECTORY_SURVEY option:selected').text();

       $('#SURVEY_TEMPLATE_SURVEY_DATA input[type=text]').val(val + "sisdata/grids");
       var toSend = $('#SURVEY_TEMPLATE_SURVEY_DATA input[type=text]').serialize();
       sendValues(toSend);
    }
    /*else if (s.indexOf('root') > -1) 
    {
       var val = $('#SURVEY_TEMPLATE_SURVEY_DATA').val();

       $('#SURVEY_TEMPLATE_TOPDIR input[type=text]').val(val);
       //$('#SURVEY_TEMPLATE_BACKGROUND_DATA input[type=text]').val(val+"/background");
       $('#SURVEY_TEMPLATE_RAW_DATA input[type=text]').val(val + "sisdata/raw");
       $('#SURVEY_TEMPLATE_SURVEY_DATA input[type=text]').val(val + "sisdata/grids");
       var toSend = $('#SURVEY_TEMPLATE_DIRECTORIES input[type=text]').serialize();
       sendValues(toSend);
     }*/
}

function realTimeCleaning(target) 
{
    window.open("./Survey_realtimeCleaning.html", "_self");
    //window.open("./SISQA_survey_realtimeCleaning.html", "_blank", "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=900, height=850");
    //window.location.assign("./SISQA_survey_realtimeCleaning.html");
}